<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <span>
        <span>انتخاب چک</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<div mat-dialog-content class="matDialogContent">
    <div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
        style='overflow-x:auto;direction:rtl;'>
        <mat-table [dataSource]="dataSource" style='min-width:100%'
            class='table-scroll mat_table_fa_without_scroll_bg pe1'
            [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
            [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">
            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                    <span *ngIf="lang == 1">ردیف</span>
                    <span *ngIf="lang == 2">#</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + 1 }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1">نوع چک</span>
                    <span *ngIf="lang == 2">Title</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)" style="max-width:100px">{{
                    x.site_cheque_type_title }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">بابت</span>
                    <span *ngIf="lang == 2">Title</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)">{{
                    x.site_cheque_title }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="user">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">نام طرف حساب</span>
                    <span *ngIf="lang == 2">Cheque Date </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)">{{
                    x.user_title }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="bank">
                <mat-header-cell *matHeaderCellDef style="max-width:90px">
                    <span *ngIf="lang == 1">بانک</span>
                    <span *ngIf="lang == 2">Bank</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)" style="max-width:90px">{{
                    x.site_bank_title }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="account">
                <mat-header-cell *matHeaderCellDef style="max-width:90px">
                    <span *ngIf="lang == 1">شماره حساب</span>
                    <span *ngIf="lang == 2">Account Number</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)" style="max-width:90px">{{
                    x.accounts_number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="cheque_number">
                <mat-header-cell *matHeaderCellDef style="max-width:90px">
                    <span *ngIf="lang == 1">شماره چک</span>
                    <span *ngIf="lang == 2">cheque number</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)" style="max-width:90px">{{
                    x.cheque_number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="date3">
                <mat-header-cell *matHeaderCellDef style="max-width: 90px;">
                    <span *ngIf="lang == 1">تاریخ سررسید</span>
                    <span *ngIf="lang == 2">Cheque Date </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)" style="max-width: 90px;">{{
                    x.site_cheque_due_date1 }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="price">
                <mat-header-cell *matHeaderCellDef style="max-width:90px">
                    <span *ngIf="lang == 1">مبلغ چک</span>
                    <span *ngIf="lang == 2">Price</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)" style="max-width:90px">{{
                    x.site_cheque_price | number}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">وضعیت چک</span>
                    <span *ngIf="lang == 2">Price</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)">{{
                    x.site_cheque_status_title }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="financial">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">سند دریافتی</span>
                    <span *ngIf="lang == 2">Document</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" (click)="select(i)">{{
                    x.finance_financial2_code }}</mat-cell>
            </ng-container>


            <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
            </mat-header-row>
            <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
                (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
                [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
                [ngStyle]="{'backgroundColor': row.site_cheque_type == 2 ? 'aqua' : 'transparent'}" class="cursor">
            </mat-row>

        </mat-table>
    </div>
</div>